import { Link } from "react-router-dom";
import WorkCard from "@/components/feature/WorkCard";
import SectionHeading from "@/components/base/SectionHeading";
import { worksList } from "@/mocks/works";

export default function FeaturedWorks() {
  const movies = worksList.filter((w) => w.category === "movie").slice(0, 3);
  const music = worksList.filter((w) => w.category === "music").slice(0, 3);

  return (
    <section className="px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <SectionHeading
        eyebrow="Selected Works"
        title="作品精选"
        description="从银幕到录音室，精选影视与音乐领域的代表作品。"
        morePath="/works"
      />

      <div className="mb-10 md:mb-12">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 flex items-center gap-2">
            <i className="ri-film-line text-primary-500"></i>
            影视作品
          </h3>
          <Link
            to="/works/movies"
            className="text-sm text-primary-600 hover:text-accent-600 transition-colors whitespace-nowrap"
          >
            更多影视
            <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {movies.map((item) => (
            <WorkCard key={item.id} item={item} />
          ))}
        </div>
      </div>

      <div>
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 flex items-center gap-2">
            <i className="ri-music-2-line text-accent-500"></i>
            音乐作品
          </h3>
          <Link
            to="/works/music"
            className="text-sm text-primary-600 hover:text-accent-600 transition-colors whitespace-nowrap"
          >
            更多音乐
            <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {music.map((item) => (
            <WorkCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}